/** Exact note text written when a company's Stripe subscription does not match what it should have. */
export const BILLING_DESYNC_NOTES = [
  "Subscription out of sync. This company is archived and should not be billed, but Stripe still has a subscription. Sync to cancel it.",
  "Subscription out of sync. This is a free account, but Stripe still has a subscription. Sync to cancel it.",
  "Subscription out of sync. Stripe has no subscription for this company. Sync to create one.",
] as const

export function billingDesyncNote(
  company: { archived: boolean; freeAccount: boolean },
  hasSubscription: boolean,
): (typeof BILLING_DESYNC_NOTES)[number] | null {
  if (company.archived && hasSubscription) return BILLING_DESYNC_NOTES[0]
  if (company.freeAccount && hasSubscription) return BILLING_DESYNC_NOTES[1]
  if (!company.archived && !company.freeAccount && !hasSubscription) return BILLING_DESYNC_NOTES[2]
  return null
}

export function notesIncludeDesyncTemplate(notes: string) {
  return BILLING_DESYNC_NOTES.some(template => notes.includes(template))
}

export function removeDesyncNotes(notes: string) {
  let result = notes
  for (const template of BILLING_DESYNC_NOTES) {
    result = result.split(template).join("")
  }
  return result
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
}

/** Replace any previous out-of-sync note with the current one, keeping other notes. */
export function applyDesyncNote(notes: string, template: string) {
  const without = removeDesyncNotes(notes)
  return without ? `${without}\n\n${template}` : template
}
